import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import template from './uploader.vue';

@Component({
    mixins: [template],
    components: {},
})
export default class Uploader extends Vue {
    @Prop({ default: false })
    error: boolean;
    fd: any = null;
    file: any = {};
    message: any = {};
    mounted() {
        let dropbox: any = document.querySelector('.dropbox');
        dropbox.addEventListener('dragenter', this.onDrag, false);
        dropbox.addEventListener('dragover', this.onDrag, false);
        dropbox.addEventListener('drop', this.onDrop, false);
    }

    onDrag(e: any) {
        e.stopPropagation();
        e.preventDefault();
    }
    onDrop(e: any) {
        e.stopPropagation();
        e.preventDefault();
        let dt = e.dataTransfer;
        this.uploadFile(dt.files);
    }

    addFile(file: any) {
        let inputDOM: any = this.$refs.inputer;
        this.$emit('addFileAction', inputDOM.files);
    }

    uploadFile(file: any) {
        console.log('uploadFile..', file);
        this.$emit('uploadFileAction', file);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/uploader/index.ts